var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgrammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.42,79.813a12.514,12.514,0,0,1-12.52,12.52h-5.06a43.411,43.411,0,0,1-17.9,28.06h-49.9a43.431,43.431,0,0,1-17.88-28.06H80.1a12.52,12.52,0,0,1,0-25.04h4.4l-.01-.01c0-8.1,0-14.131.01-18.831h87V67.293h4.4A12.519,12.519,0,0,1,188.42,79.813Z",
    fill: "#ffb69f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.95,42.932l-5.44,5.51V73.073L154.03,48.452H101.97L84.49,73.073v-5.79c0-8.1,0-14.131.01-18.831v-12.6A19.751,19.751,0,0,1,104.24,16.1h46.94A14.936,14.936,0,0,0,165.85,3.952l7.87,5.4A21.985,21.985,0,0,1,176.95,42.932Z",
    fill: "#f0c020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.9,120.388H30.99a9.942,9.942,0,0,0-9.95,9.94V242.1a9.944,9.944,0,0,0,9.95,9.95H222.9a9.95,9.95,0,0,0,9.95-9.95V130.328A9.948,9.948,0,0,0,222.9,120.388Z",
    fill: "#afafaf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.85,242.549H49.51a2.5,2.5,0,0,1,0-5H218.35V132.389a2.5,2.5,0,0,1,5,0v107.66A2.5,2.5,0,0,1,220.85,242.549Zm-181.34,0H33.04a2.5,2.5,0,1,1,0-5h6.47a2.5,2.5,0,1,1,0,5Z",
    fill: "#efefef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128,212.9a24.965,24.965,0,1,1,15.78-44.31,10.19,10.19,0,0,0,9.09,17.31A24.961,24.961,0,0,1,128,212.9Z",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 111.38,
    cy: 16.102,
    r: 2.5,
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,97.852a2.558,2.558,0,0,0-3.22-1.47,2.494,2.494,0,0,0-1.47,3.21,16.042,16.042,0,0,0,30.03.01,2.511,2.511,0,0,0-1.47-3.22,2.546,2.546,0,0,0-3.21,1.47,11.037,11.037,0,0,1-20.66,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.255,70.7v3.772a2.5,2.5,0,1,0,5,0V70.7a2.5,2.5,0,0,0-5,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.745,70.7v3.772a2.5,2.5,0,1,0,5,0V70.7a2.5,2.5,0,0,0-5,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,89.385V73.257a2.5,2.5,0,0,0-5,0V89.385a2.5,2.5,0,0,0,5,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,105.162a2.5,2.5,0,1,0,.84,3.43A2.483,2.483,0,0,0,166.51,105.162Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,117.892H159.883c.335-.321.673-.639,1-.97a2.518,2.518,0,0,0-.04-3.54,2.575,2.575,0,0,0-3.54.04,42.214,42.214,0,0,1-5.16,4.47h-48.3A40.943,40.943,0,0,1,87,84.753V73.864l16.255-22.912h49.49L169,73.863v10.89a42.73,42.73,0,0,1-.624,7.139v.013A41.926,41.926,0,0,1,167,97.452a2.5,2.5,0,0,0,1.6,3.15,2.532,2.532,0,0,0,3.15-1.6c.443-1.368.8-2.766,1.111-4.17H175.9a15.02,15.02,0,1,0,0-30.039h-1.894V49.469l4.723-4.777a24.5,24.5,0,0,0-3.6-37.41l-7.87-5.39a2.5,2.5,0,0,0-3.87,1.6A12.431,12.431,0,0,1,151.18,13.6h-29.8a2.5,2.5,0,0,0,0,5h29.8a17.363,17.363,0,0,0,16.06-10.66l5.07,3.47a19.5,19.5,0,0,1,2.86,29.76l-4.71,4.77H86.99V35.852a17.345,17.345,0,0,1,14.76-17.07,2.5,2.5,0,0,0,2.12-2.83,2.537,2.537,0,0,0-2.84-2.11,22.266,22.266,0,0,0-19.04,22.01c0,5.571.005,13.671.005,28.942H80.1a15.02,15.02,0,1,0,0,30.039h3.018a45.723,45.723,0,0,0,12.975,23.059H30.99a12.462,12.462,0,0,0-12.45,12.44v72.461a2.5,2.5,0,0,0,5,0V130.332a7.482,7.482,0,0,1,7.45-7.45H222.9a7.482,7.482,0,0,1,7.451,7.45V242.1a7.481,7.481,0,0,1-7.451,7.45H30.99a7.481,7.481,0,0,1-7.45-7.45V222.793a2.5,2.5,0,0,0-5,0V242.1a12.463,12.463,0,0,0,12.45,12.441H222.9A12.463,12.463,0,0,0,235.35,242.1V130.332A12.462,12.462,0,0,0,222.9,117.892ZM87,65.223V50.952H97.124Zm71.876-14.271H169v14.27ZM175.9,69.794a10.02,10.02,0,1,1,0,20.039h-2.176c.132-1.177.281-3.446.281-5.079V69.794ZM80.1,89.833a10.02,10.02,0,1,1,0-20.039H82v14.96c0,1.419.135,3.78.278,5.079Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.04,215.293a2.506,2.506,0,1,0-2.5-2.5A2.508,2.508,0,0,0,21.04,215.293Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,148.722a2.5,2.5,0,0,0-2.5,2.5v9.366a27.463,27.463,0,1,0,29.859,25.094,2.5,2.5,0,0,0-2.979-2.24,7.687,7.687,0,0,1-6.86-13.06,2.493,2.493,0,0,0-.161-3.73,27.4,27.4,0,0,0-14.859-6.06v-9.37A2.5,2.5,0,0,0,128,148.722Zm22.46,39.87a22.441,22.441,0,1,1-10.271-19.54,12.694,12.694,0,0,0,10.271,19.54Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,56.853H17.26a2.5,2.5,0,0,0,0-5H14.38V38.214a2.5,2.5,0,0,0-3.62-2.241L5.7,38.514a2.511,2.511,0,0,0-1.12,3.359,2.546,2.546,0,0,0,3.36,1.111l1.44-.72v9.589H6.5a2.5,2.5,0,0,0,0,5Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.76,108.364a2.5,2.5,0,0,0-2.5-2.5H14.38V92.214a2.5,2.5,0,0,0-3.62-2.23L5.7,92.524a2.5,2.5,0,0,0-1.12,3.36,2.548,2.548,0,0,0,3.36,1.11l1.44-.73v9.6H6.5a2.5,2.5,0,0,0,0,5H17.26A2.5,2.5,0,0,0,19.76,108.364Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.88,29.853a7.889,7.889,0,0,0,7.88-7.88V16.594a7.88,7.88,0,1,0-15.76,0v5.379A7.9,7.9,0,0,0,11.88,29.853ZM9,16.594a2.885,2.885,0,1,1,5.77,0v5.379a2.885,2.885,0,0,1-5.77,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.88,83.864a7.891,7.891,0,0,0,7.88-7.891V70.594a7.88,7.88,0,0,0-15.76,0v5.379A7.9,7.9,0,0,0,11.88,83.864ZM9,70.594a2.885,2.885,0,0,1,5.77,0v5.379a2.885,2.885,0,1,1-5.77,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17,83.864H44.93a2.5,2.5,0,1,0,0-5H42.05V65.214a2.506,2.506,0,0,0-3.62-2.241l-5.07,2.551a2.488,2.488,0,0,0-1.11,3.349,2.556,2.556,0,0,0,3.36,1.121l1.44-.73v9.6H34.17a2.5,2.5,0,0,0,0,5Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17,24.853a2.5,2.5,0,0,0,0,5H44.93a2.5,2.5,0,0,0,0-5H42.05V11.2a2.5,2.5,0,0,0-3.62-2.23l-5.07,2.541a2.5,2.5,0,0,0-1.11,3.359,2.553,2.553,0,0,0,3.36,1.111l1.44-.73v9.6Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.55,56.853a7.882,7.882,0,0,0,7.88-7.88V43.594a7.88,7.88,0,1,0-15.76,0v5.379A7.888,7.888,0,0,0,39.55,56.853ZM36.67,43.594a2.88,2.88,0,1,1,5.76,0v5.379a2.88,2.88,0,0,1-5.76,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.55,110.864a7.889,7.889,0,0,0,7.88-7.88V97.6a7.88,7.88,0,1,0-15.76,0v5.381A7.9,7.9,0,0,0,39.55,110.864ZM36.67,97.6a2.88,2.88,0,1,1,5.76,0v5.381a2.88,2.88,0,0,1-5.76,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,83.864h10.76a2.5,2.5,0,0,0,0-5h-2.88V65.214a2.5,2.5,0,0,0-3.62-2.23l-5.07,2.54a2.489,2.489,0,0,0-1.11,3.349,2.559,2.559,0,0,0,3.36,1.121l1.44-.73v9.6H212.1a2.5,2.5,0,0,0,0,5Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,24.853a2.5,2.5,0,0,0,0,5h10.76a2.5,2.5,0,0,0,0-5h-2.88V11.2a2.5,2.5,0,0,0-3.62-2.23l-5.07,2.541a2.5,2.5,0,0,0-1.11,3.359,2.556,2.556,0,0,0,3.36,1.111l1.44-.72v9.589Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,56.853a7.882,7.882,0,0,0,7.88-7.88V43.594a7.88,7.88,0,0,0-15.76,0v5.379A7.888,7.888,0,0,0,217.48,56.853ZM214.6,43.594a2.88,2.88,0,0,1,5.76,0v5.379a2.88,2.88,0,0,1-5.76,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,110.864a7.889,7.889,0,0,0,7.88-7.88V97.6a7.88,7.88,0,1,0-15.76,0v5.381A7.9,7.9,0,0,0,217.48,110.864ZM214.6,97.6a2.88,2.88,0,1,1,5.76,0v5.381a2.88,2.88,0,0,1-5.76,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5,51.853h-2.88V38.214A2.507,2.507,0,0,0,243,35.973l-5.07,2.541a2.5,2.5,0,0,0-1.11,3.359,2.534,2.534,0,0,0,3.35,1.111l1.45-.72v9.589h-2.89a2.5,2.5,0,1,0,0,5H249.5a2.5,2.5,0,0,0,0-5Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5,105.864h-2.88V92.214a2.5,2.5,0,0,0-3.62-2.23l-5.07,2.54a2.5,2.5,0,0,0-1.11,3.36,2.537,2.537,0,0,0,3.35,1.11l1.45-.72v9.59h-2.89a2.5,2.5,0,0,0,0,5H249.5a2.5,2.5,0,0,0,0-5Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,8.7a7.9,7.9,0,0,0-7.89,7.88v5.39a7.885,7.885,0,0,0,15.77,0v-5.39A7.9,7.9,0,0,0,244.12,8.7ZM247,21.973a2.885,2.885,0,0,1-5.77,0v-5.39a2.885,2.885,0,0,1,5.77,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,62.714a7.9,7.9,0,0,0-7.89,7.88v5.39a7.885,7.885,0,0,0,15.77,0v-5.39A7.9,7.9,0,0,0,244.12,62.714ZM247,75.984a2.885,2.885,0,0,1-5.77,0v-5.39a2.885,2.885,0,0,1,5.77,0Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammer);
export default __webpack_public_path__ + "static/media/programmer.3fc6f2aa110bca7acf5b9607aa1fdb34.svg";
export { ForwardRef as ReactComponent };